<template>
	<router-link to="/add/patient">
		Enroll Patients
		<EnrollIcon></EnrollIcon>
	</router-link>
</template>

<script>
import EnrollIcon from './EnrollIcon'

export default {
	name: 'sidebar-patient-enroll-action',
	components: {
		EnrollIcon
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
